'use client';

import * as React from 'react';
import Image from 'next/image';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import Tick from 'public/shared-icons/tick.svg';

import { cn } from '@/lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-[2px] border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-[#34BCAF] data-[state=checked]:bg-[#34BCAF] data-[state=checked]:text-white',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn(
        'flex h-full w-full items-center justify-center text-current'
      )}
    >
      {/* Show tick for checked state */}
      {props.checked === true && (
        <Image
          src={Tick}
          alt="tick icon"
          width={16}
          height={16}
          className="p-[1px]"
        />
      )}

      {/* Show square for indeterminate state */}
      {props.checked === 'indeterminate' && <div className="size-2 bg-jade" />}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
